<app-youtube-live [fromModal]="true" (emitClose)="close()"></app-youtube-live>